import _classCallCheck from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import HTMLMaskElement from './html-mask-element.js';
import IMask from '../core/holder.js';
import './mask-element.js';
/** Bridge between InputElement and {@link Masked} */

var HTMLInputMaskElement =
/*#__PURE__*/
function (_HTMLMaskElement) {
  _inherits(HTMLInputMaskElement, _HTMLMaskElement);

  /** InputElement to use mask on */
  function HTMLInputMaskElement(input) {
    var _this;

    _classCallCheck(this, HTMLInputMaskElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLInputMaskElement).call(this, input));
    _this.input = input;
    _this._handlers = {};
    return _this;
  }
  /** Returns InputElement selection start */


  _createClass(HTMLInputMaskElement, [{
    key: "_unsafeSelect",

    /** Sets InputElement selection */
    value: function _unsafeSelect(start, end) {
      this.input.setSelectionRange(start, end);
    }
  }, {
    key: "_unsafeSelectionStart",
    get: function get() {
      return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }
    /** Returns InputElement selection end */

  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      return this.input.selectionEnd;
    }
  }, {
    key: "value",
    get: function get() {
      return this.input.value;
    },
    set: function set(value) {
      this.input.value = value;
    }
  }]);

  return HTMLInputMaskElement;
}(HTMLMaskElement);

IMask.HTMLMaskElement = HTMLMaskElement;
export { HTMLInputMaskElement as default };